export default {
  root: {
    padding: '40px 74px',
  },
};
